module.exports = __webpack_public_path__ + "img/Bridge.d83e5a90.jpg";